export default __webpack_public_path__ + "static/media/BalooBhaina2.4896b909.ttf";